import React, { useEffect, useState } from "react";
import axios from "axios";
import * as z from "zod";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "src/@/components/ui/card";
import { Button } from "src/@/components/ui/button";
import { CHAT_MESSAGES, NUSA1, PRODUCTS } from "src/utils/constants";
import { Badge } from "src/@/components/ui/badge";
import { Input } from "src/@/components/ui/input";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast } from "react-toastify";
import { FACEBOOK_LOGIN_SCOPE } from "src/utils/facebookLoginScopes";

import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "src/@/components/ui/tabs";

import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "src/@/components/ui/table";

import { cn } from "src/@/lib/utils";
import { LineChart } from "src/components/designSystem/organisms/LineChart";
import {
  getFacebookMentions,
  getFacebookConversations,
  getFacebookInsights,
  getFacebookBusinessDiscovery,
} from "src/api/facebook";
import {
  createPartnershipAd,
  listPartnershipAds,
  goLivePartnershipAd,
  setPartnershipAdStatus,
  deletePartnershipAd,
  getPartnershipAdStatus,
  getAdsCampaignsLive,
} from "src/api/ads";

const formSchema = z.object({
  to: z.string(),
  link: z.string(),
  product: z.string(),
  price: z.string(),
});

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const redirectUri = process.env.REACT_APP_REDIRECT_URI;

export const Dashboard: React.FC = () => {
  const [openChatText, setOpenChatText] = useState<number | undefined>(
    undefined
  );

  const [isLogin, setIsLogin] = useState(
    sessionStorage.getItem("instaLoginStatus")
  );

  const [SelectedChat, setSelectedChat] = useState(0);

  // graph.facebook.com data (proxied through our backend).
  const [fbMentions, setFbMentions] = useState<any[]>([]);
  const [fbAccount, setFbAccount] = useState<any>(null);
  const [fbConversations, setFbConversations] = useState<any[]>([]);
  const [fbInsights, setFbInsights] = useState<any[]>([]);
  const [fbInsightsError, setFbInsightsError] = useState<string | null>(null);
  const [fbLoading, setFbLoading] = useState(false);
  const [discovery, setDiscovery] = useState<any>(null);
  const [discoveryUsername, setDiscoveryUsername] = useState("");
  const [discoveryLoading, setDiscoveryLoading] = useState(false);
  const [discoveryError, setDiscoveryError] = useState<string | null>(null);

  // Partnership ads (Meta Marketing API), keyed by creator media id.
  const [adsByMedia, setAdsByMedia] = useState<Record<string, any>>({});
  const [boostFor, setBoostFor] = useState<any>(null); // media being boosted
  const [boosting, setBoosting] = useState(false);
  const [adActionId, setAdActionId] = useState<string | null>(null);
  const [expandedCampaigns, setExpandedCampaigns] = useState<
    Record<string, boolean>
  >({});
  const [liveCampaigns, setLiveCampaigns] = useState<any[]>([]);
  const [liveLoading, setLiveLoading] = useState(false);
  const [liveError, setLiveError] = useState<string | null>(null);
  const [adAccountId, setAdAccountId] = useState<string>("");
  const [businessId, setBusinessId] = useState<string>("");
  const [boostForm, setBoostForm] = useState({
    name: "",
    objective: "OUTCOME_AWARENESS",
    dailyBudgetUsd: 20,
    countries: "US",
    ctaType: "LEARN_MORE",
    ctaLink: "",
    dryRun: false,
  });

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      to: "",
      link: PRODUCTS[0].link,
      product: PRODUCTS[0].SKU,
      price: `${PRODUCTS[0].price}`,
    },
  });

  function onSubmit(values: z.infer<typeof formSchema>) {
    toast.success("Message sent!");
    setOpenChatText(undefined);
  }

  const setFormValues = (data: { to: string }) => {
    form.setValue("to", data.to);
  };

  const checkInstaLoginStatus = () => {
    return sessionStorage.getItem("instaLoginStatus");
  };

  const handleAuthorizationCode = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const authorizationCode = urlSearchParams.get("code");
    if (authorizationCode) {
      try {
        const response = await axios.post(`${backendUrl}auth/facebook`, {
          code: authorizationCode,
        });
        axios
          .post(`${backendUrl}auth/facebook`, {
            code: authorizationCode,
          })
          .then((res) => {
            console.log("res", res);
          })
          .catch((err) => {
            console.log("====================================");
            console.log("err", err);
            console.log("====================================");
          });

        const data = response.data;
        console.log(data); // This will indicate success or any error messages from the backend
      } catch (error) {
        console.log("Error:", error);
      }
    }
  };
  useEffect(() => {
    handleAuthorizationCode();
  }, []);

  const handleFacebookLogin = async () => {
    try {
      if (typeof FB !== "undefined" && typeof FB === "object") {
        console.log("Initiate the Facebook login process");
        FB.login(
          async (response) => {
            if (response.authResponse) {
              const accessToken = response.authResponse.accessToken;
              console.log("Facebook Access Token:", response, accessToken);
              // @ts-ignore
              localStorage.setItem("fbAccessToken", response);
              await getUserDetails({
                userId: response.authResponse.userID,
              });
              setIsLogin("true");
            } else {
              console.log("Facebook Login canceled or not authorized.");
            }
          },
          {
            scope: FACEBOOK_LOGIN_SCOPE,
          }
          // {
          //   scope:"instagram_manage_comments,instagram_manage_insights,instagram_content_publish,instagram_manage_messages,pages_read_engagement,pages_read_user_content,public_profile"
          // }
        ); // Add additional permissions if needed
      } else {
        // 'FB' is not available, handle this case
        console.log("Facebook SDK not loaded.");
      }
    } catch (error) {
      console.log("fb login error", error);
    }
  };

  const getUserDetails = async ({ userId }: { userId: string }) => {
    if (typeof FB !== "undefined" && typeof FB === "object") {
      FB.api(`/${userId}/`, function (response) {
        // @ts-ignore
        if (response && !response.error) {
          console.log("response", response);
          // @ts-ignore
          localStorage.setItem("fbUserDetails", JSON.stringify(response));
        }
      });
      FB.api("/me/accounts", {}, function (response) {
        // @ts-ignore
        if (response && !response.error) {
          console.log("response", response);
          // @ts-ignore
          localStorage.setItem("fbUserPages", JSON.stringify(response));
          localStorage.setItem(
            "fbUserPageData",
            JSON.stringify({
              // @ts-ignore
              id: response.data[0].id,
              // @ts-ignore
              access_token: response.data[0].access_token,
            })
          );
          FB.api(
            // @ts-ignore
            `/${response.data[0].id}/${response.data[0].access_token}`,
            {},
            function (response) {
              // @ts-ignore
              if (response && !response.error) {
                console.log("response", response);
                // @ts-ignore
                localStorage.setItem("fbUserPages", JSON.stringify(response));
              }
            }
          );
        }
      });
    }
  };

  const getConersations = async () => {
    if (typeof FB !== "undefined" && typeof FB === "object") {
      const pageData = JSON.parse(
        // @ts-ignore
        localStorage.getItem("fbUserPageData")
      );
      FB.api(
        `/${pageData.id}/conversations`,
        {
          fields: `id,name,updated_time,messages{story,tags,message,created_time},participants&platform=instagram&access_token=${pageData.access_token}`,
        },
        function (response) {
          // @ts-ignore
          if (response && !response.error) {
            console.log("response", response);
            // @ts-ignore
            localStorage.setItem("fbConversations", JSON.stringify(response));
          }
        }
      );
    }
  };

  // Load all graph.facebook.com tab data once a page is connected.
  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setFbLoading(true);
      try {
        const [mentionsRes, convoRes, insightsRes] = await Promise.allSettled([
          getFacebookMentions(),
          getFacebookConversations(),
          getFacebookInsights(),
        ]);
        if (cancelled) return;
        if (mentionsRes.status === "fulfilled") {
          setFbMentions(mentionsRes.value?.data || []);
          setFbAccount(mentionsRes.value?.account || null);
        }
        if (convoRes.status === "fulfilled") {
          setFbConversations(convoRes.value?.data || []);
        }
        if (insightsRes.status === "fulfilled") {
          setFbInsights(insightsRes.value?.data || []);
          setFbInsightsError(insightsRes.value?.error || null);
        }
      } finally {
        if (!cancelled) setFbLoading(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const runDiscovery = async () => {
    const username = discoveryUsername.trim();
    if (!username) return;
    setDiscoveryLoading(true);
    setDiscoveryError(null);
    setDiscovery(null);
    try {
      const res = await getFacebookBusinessDiscovery(username);
      setDiscovery(res?.data || null);
    } catch (err: any) {
      setDiscoveryError(
        err?.response?.data?.error || err?.message || "Lookup failed",
      );
    } finally {
      setDiscoveryLoading(false);
    }
  };

  // Load existing partnership ads once, index them by creator media id.
  useEffect(() => {
    listPartnershipAds()
      .then((res) => {
        const map: Record<string, any> = {};
        (res?.data || []).forEach((a: any) => {
          if (a.creatorMediaId && a.status !== "DELETED")
            map[a.creatorMediaId] = a;
        });
        setAdsByMedia(map);
      })
      .catch(() => {});
  }, []);

  const openBoost = (m: any) => {
    setBoostFor(m);
    setBoostForm({
      name: `Boost @${m.username || "creator"}`,
      objective: "OUTCOME_AWARENESS",
      dailyBudgetUsd: 20,
      countries: "US",
      ctaType: "LEARN_MORE",
      ctaLink: "",
      dryRun: false,
    });
  };

  const submitBoost = async () => {
    if (!boostFor) return;
    setBoosting(true);
    try {
      const payload = {
        creatorMediaId: boostFor.id,
        creatorUsername: boostFor.username,
        name: boostForm.name,
        objective: boostForm.objective,
        dailyBudget: Math.round(Number(boostForm.dailyBudgetUsd) * 100),
        countries: boostForm.countries
          .split(",")
          .map((c) => c.trim().toUpperCase())
          .filter(Boolean),
        cta: boostForm.ctaType
          ? {
              type: boostForm.ctaType,
              ...(boostForm.ctaLink ? { link: boostForm.ctaLink } : {}),
            }
          : null,
        dryRun: boostForm.dryRun,
      };
      const res = await createPartnershipAd(payload);
      if (boostForm.dryRun) {
        toast.success("Dry run — payload logged, nothing created");
      } else {
        const record = res?.data;
        if (record?.creatorMediaId) {
          setAdsByMedia((prev) => ({
            ...prev,
            [record.creatorMediaId]: record,
          }));
        }
        toast.success(
          res?.idempotent
            ? "An ad already exists for this post"
            : "Partnership ad created (paused)",
        );
        setBoostFor(null);
      }
    } catch (err: any) {
      toast.error(
        err?.response?.data?.error || err?.message || "Failed to create ad",
      );
    } finally {
      setBoosting(false);
    }
  };

  const updateAdRecord = (rec: any) =>
    setAdsByMedia((prev) => ({ ...prev, [rec.creatorMediaId]: rec }));

  const handleGoLive = async (rec: any) => {
    setAdActionId(rec._id);
    try {
      const res = await goLivePartnershipAd(rec._id);
      updateAdRecord(res?.data || { ...rec, status: "ACTIVE" });
      toast.success("Ad launched — pending Meta review");
      loadLiveCampaigns();
    } catch (err: any) {
      toast.error(err?.response?.data?.error || err?.message || "Launch failed");
    } finally {
      setAdActionId(null);
    }
  };

  const handleAdStatus = async (rec: any, status: string) => {
    setAdActionId(rec._id);
    try {
      const res = await setPartnershipAdStatus(rec._id, status);
      updateAdRecord(res?.data || { ...rec, status });
      toast.success(`Ad ${status.toLowerCase()}`);
      loadLiveCampaigns();
    } catch (err: any) {
      toast.error(err?.response?.data?.error || err?.message || "Update failed");
    } finally {
      setAdActionId(null);
    }
  };

  const handleDeleteAd = async (rec: any) => {
    if (
      !window.confirm(
        "Permanently delete this ad campaign? This cannot be undone.",
      )
    )
      return;
    setAdActionId(rec._id);
    try {
      await deletePartnershipAd(rec._id);
      setAdsByMedia((prev) => {
        const next = { ...prev };
        delete next[rec.creatorMediaId];
        return next;
      });
      toast.success("Ad deleted");
      loadLiveCampaigns();
    } catch (err: any) {
      toast.error(err?.response?.data?.error || err?.message || "Delete failed");
    } finally {
      setAdActionId(null);
    }
  };

  const handleRefreshStatus = async (rec: any) => {
    setAdActionId(rec._id);
    try {
      const res = await getPartnershipAdStatus(rec._id);
      const eff = res?.data?.effective_status || "";
      updateAdRecord({ ...rec, lastEffectiveStatus: eff });
      toast.success(`Effective status: ${eff || "unknown"}`);
    } catch (err: any) {
      toast.error(
        err?.response?.data?.error || err?.message || "Status check failed",
      );
    } finally {
      setAdActionId(null);
    }
  };

  // Live campaign -> ad set -> ad -> creative tree from Meta (Ads tab).
  const loadLiveCampaigns = async () => {
    setLiveLoading(true);
    setLiveError(null);
    try {
      const res = await getAdsCampaignsLive();
      setLiveCampaigns(res?.data || []);
      setAdAccountId(res?.adAccountId || "");
      setBusinessId(res?.businessId || "");
    } catch (err: any) {
      setLiveError(
        err?.response?.data?.error || err?.message || "Failed to load ads",
      );
    } finally {
      setLiveLoading(false);
    }
  };
  useEffect(() => {
    loadLiveCampaigns();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Our record for a live object, matched by campaign id (for lifecycle actions).
  const recordForCampaign = (campaignId: string) =>
    Object.values(adsByMedia).find((r: any) => r.campaignId === campaignId) ||
    null;
  // Partnership ads can only run on permanent media (feed posts / reels).
  // Story mentions are ephemeral and can't be boosted.
  const isBoostable = (m: any) => {
    const pt = (m.media_product_type || "").toUpperCase();
    if (pt === "STORY") return false;
    if (pt) return pt === "REELS" || pt === "FEED" || pt === "AD";
    // No product type returned -> fall back to media_type.
    return ["IMAGE", "VIDEO", "CAROUSEL_ALBUM"].includes(
      (m.media_type || "").toUpperCase(),
    );
  };
  // Join a boosted post's thumbnail from Mentions data by media id.
  const mediaInfo = (mediaId: string) =>
    fbMentions.find((m: any) => m.id === mediaId) || null;
  // Deep link into Ads Manager for a campaign (optionally pre-selecting an ad set).
  const adsManagerUrl = (campaignId: string, adsetId?: string) => {
    const act = (adAccountId || "").replace(/^act_/, "");
    if (!act || !campaignId) return null;
    const params = new URLSearchParams({ act });
    if (businessId) {
      params.set("business_id", businessId);
      params.set("global_scope_id", businessId);
    }
    params.set("selected_campaign_ids", campaignId);
    if (adsetId) params.set("selected_adset_ids", adsetId);
    return `https://adsmanager.facebook.com/adsmanager/manage/ads?${params.toString()}`;
  };

  // Badge colour for a Meta status / effective_status.
  const effClass = (s = "") =>
    s === "ACTIVE"
      ? "bg-green-600"
      : /DISAPPROVED|ERROR|WITH_ISSUES|DENIED/.test(s)
        ? "bg-red-600"
        : /PENDING|IN_REVIEW|REVIEW/.test(s)
          ? "bg-blue-500"
          : /PAUSED/.test(s)
            ? "bg-yellow-500"
            : "bg-gray-500";

  return (
    <>
      <div className="w-screen h-screen">
        <div className="flex items-baseline justify-center pt-20">
          <div className="flex flex-col items-center">
            <Card className="w-[500px]">
              <CardHeader>
                <CardTitle className="text-center">
                  Connect you facbook account
                </CardTitle>
              </CardHeader>
              <CardContent className="text-center">
                {isLogin !== "true" ? (
                  <Button
                    onClick={() => {
                      handleFacebookLogin();
                    }}
                  >
                    Login with Facebook
                  </Button>
                ) : (
                  <Button
                    onClick={() => {
                      FB.logout();
                    }}
                  >
                    Logout
                  </Button>
                )}
              </CardContent>
              <CardFooter className="flex justify-between">
                {!checkInstaLoginStatus() && (
                  <p className="text-center">
                    Please connect your facebook account to get started with
                    Creator Gifting
                  </p>
                )}
              </CardFooter>
            </Card>

            {checkInstaLoginStatus() && (
              <Card className="w-[1000px] mt-20">
                <Tabs defaultValue="account" className="w-[1000px]">
                  <TabsList>
                    <TabsTrigger value="account">Mentions</TabsTrigger>
                    <TabsTrigger value="password">Chat</TabsTrigger>
                    <TabsTrigger value="stats">Stats</TabsTrigger>
                    <TabsTrigger value="discovery">Discovery</TabsTrigger>
                    <TabsTrigger value="ads">Ads</TabsTrigger>
                  </TabsList>

                  {/* Mentions - tagged media via graph.facebook.com */}
                  <TabsContent value="account">
                    {fbLoading ? (
                      <p className="p-6">Loading mentions...</p>
                    ) : fbMentions.length === 0 ? (
                      <p className="p-6 text-gray-500">No mentions found.</p>
                    ) : (
                      <Table>
                        <TableCaption>
                          Instagram posts that tagged @
                          {fbAccount?.username || "you"}
                        </TableCaption>
                        <TableHeader>
                          <TableRow>
                            <TableHead>Post</TableHead>
                            <TableHead>Username</TableHead>
                            <TableHead>Type</TableHead>
                            <TableHead>Likes</TableHead>
                            <TableHead>Comments</TableHead>
                            <TableHead>Time</TableHead>
                            <TableHead>Caption</TableHead>
                            <TableHead className="text-right">Link</TableHead>
                            <TableHead className="text-right">Ad</TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {fbMentions.map((m: any) => (
                            <TableRow key={m.id}>
                              <TableCell>
                                {m.thumbnail_url || m.media_url ? (
                                  <img
                                    src={m.thumbnail_url || m.media_url}
                                    alt="post"
                                    className="w-16 h-16 object-cover rounded"
                                  />
                                ) : (
                                  "-"
                                )}
                              </TableCell>
                              <TableCell>
                                <Badge>@{m.username || "-"}</Badge>
                              </TableCell>
                              <TableCell>
                                <div className="text-sm">
                                  {m.media_product_type || m.media_type || "-"}
                                </div>
                                {m.media_product_type && m.media_type && (
                                  <div className="text-xs text-gray-400">
                                    {m.media_type}
                                  </div>
                                )}
                              </TableCell>
                              <TableCell>{m.like_count ?? "-"}</TableCell>
                              <TableCell>{m.comments_count ?? "-"}</TableCell>
                              <TableCell>
                                {m.timestamp
                                  ? new Date(m.timestamp).toLocaleString()
                                  : "-"}
                              </TableCell>
                              <TableCell className="max-w-[200px] truncate">
                                {m.caption || "-"}
                              </TableCell>
                              <TableCell className="text-right">
                                {m.permalink ? (
                                  <a
                                    href={m.permalink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                  >
                                    View
                                  </a>
                                ) : (
                                  "-"
                                )}
                              </TableCell>
                              <TableCell className="text-right">
                                {adsByMedia[m.id] ? (
                                  <Badge className="bg-blue-600">
                                    In Ads ✓
                                  </Badge>
                                ) : isBoostable(m) ? (
                                  <Button
                                    className="h-7 px-2 text-xs"
                                    onClick={() => openBoost(m)}
                                  >
                                    Boost
                                  </Button>
                                ) : (
                                  <span
                                    className="text-xs text-gray-400"
                                    title="Stories can't be used for partnership ads — only feed posts and reels."
                                  >
                                    Not boostable
                                  </span>
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    )}
                  </TabsContent>

                  {/* Chat - Instagram DM conversations via graph.facebook.com */}
                  <TabsContent value="password">
                    <div className="flex h-[300px] justify-between border-t">
                      <ul className="w-[300px] border-r overflow-y-auto">
                        {fbConversations.length === 0 && (
                          <li className="px-6 py-4 text-gray-500">
                            No conversations.
                          </li>
                        )}
                        {fbConversations.map((c: any, i: number) => {
                          const who =
                            c.participants?.data?.find((p: any) => p.username)
                              ?.username || c.id;
                          return (
                            <li
                              className={cn(
                                "flex justify-between px-6 py-4 border-b cursor-pointer",
                                { "bg-blue-500 text-white": SelectedChat === i },
                              )}
                              key={c.id || i}
                              onClick={() => setSelectedChat(i)}
                            >
                              <p>{who}</p>
                            </li>
                          );
                        })}
                      </ul>
                      <div className="w-full p-4 overflow-y-auto">
                        <ul className="flex flex-col w-full h-full">
                          {(
                            fbConversations[SelectedChat]?.messages?.data || []
                          ).map((x: any, i: number) => {
                            const mine =
                              x.from?.username &&
                              x.from.username === fbAccount?.username;
                            return (
                              <li
                                className={cn("mb-2", {
                                  "flex justify-end": mine,
                                  "flex justify-start": !mine,
                                })}
                                key={x.id || i}
                              >
                                <Badge
                                  className={mine ? "bg-green-500" : "bg-blue-500"}
                                >
                                  {x.message || "(no text)"}
                                </Badge>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </TabsContent>

                  {/* Stats - account insights via graph.facebook.com */}
                  <TabsContent value="stats">
                    <div className="p-6">
                      {fbInsightsError ? (
                        <p className="text-red-500">{fbInsightsError}</p>
                      ) : fbInsights.length === 0 ? (
                        <p className="text-gray-500">No insights available.</p>
                      ) : (
                        <div className="grid grid-cols-2 gap-4">
                          {fbInsights.map((m: any) => (
                            <div
                              key={m.name}
                              className="border rounded p-4 text-center"
                            >
                              <div className="text-2xl font-bold">
                                {m.total_value?.value ??
                                  m.values?.[0]?.value ??
                                  0}
                              </div>
                              <div className="text-sm text-gray-500">
                                {m.title || m.name}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                      <div className="mt-8">
                        <LineChart width="744px" height="240px" />
                      </div>
                    </div>
                  </TabsContent>

                  {/* Discovery - public account lookup via business_discovery */}
                  <TabsContent value="discovery">
                    <div className="p-6">
                      <div className="flex gap-2 mb-4">
                        <Input
                          placeholder="Instagram username (e.g. natgeo)"
                          value={discoveryUsername}
                          onChange={(e) => setDiscoveryUsername(e.target.value)}
                        />
                        <Button
                          onClick={runDiscovery}
                          disabled={
                            discoveryLoading || !discoveryUsername.trim()
                          }
                        >
                          {discoveryLoading ? "Searching..." : "Look up"}
                        </Button>
                      </div>
                      {discoveryError && (
                        <p className="text-red-500">{discoveryError}</p>
                      )}
                      {discovery && (
                        <div className="flex items-center gap-4 border rounded p-4">
                          {discovery.profile_picture_url && (
                            <img
                              src={discovery.profile_picture_url}
                              alt={discovery.username}
                              className="w-16 h-16 rounded-full"
                            />
                          )}
                          <div>
                            <div className="font-bold">
                              @{discovery.username}{" "}
                              <span className="font-normal text-gray-500">
                                {discovery.name}
                              </span>
                            </div>
                            <div className="text-sm">
                              {discovery.followers_count} followers ·{" "}
                              {discovery.media_count} posts
                            </div>
                            <div className="text-sm text-gray-600 max-w-md">
                              {discovery.biography}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </TabsContent>

                  {/* Ads - partnership ad campaigns (accordion) */}
                  <TabsContent value="ads">
                    <div className="p-6">
                      <div className="flex items-center justify-between mb-3">
                        <h2 className="text-lg font-bold">Ad Campaigns</h2>
                        <button
                          onClick={loadLiveCampaigns}
                          disabled={liveLoading}
                          className="text-sm text-gray-600 hover:text-blue-600 disabled:opacity-50"
                        >
                          {liveLoading ? "Refreshing..." : "Refresh"}
                        </button>
                      </div>
                      {liveError ? (
                        <p className="text-red-500">{liveError}</p>
                      ) : liveLoading && liveCampaigns.length === 0 ? (
                        <p className="text-gray-500">Loading ads...</p>
                      ) : liveCampaigns.length === 0 ? (
                        <p className="text-gray-500">
                          No ads yet. Boost a post from the Mentions tab.
                        </p>
                      ) : (
                        <div className="space-y-3">
                          {liveCampaigns.map((c: any) => {
                            const open = !!expandedCampaigns[c.id];
                            const adsets = c.adsets?.data || [];
                            const totalBudget =
                              adsets.reduce(
                                (s: number, a: any) =>
                                  s + Number(a.daily_budget || 0),
                                0,
                              ) || Number(c.daily_budget || 0);
                            const rec = recordForCampaign(c.id);
                            const busy = rec && adActionId === rec._id;
                            return (
                              <div
                                key={c.id}
                                className="border rounded-lg overflow-hidden"
                              >
                                {/* Campaign header */}
                                <div className="w-full flex items-center justify-between px-4 py-3 bg-gray-50">
                                  <button
                                    onClick={() =>
                                      setExpandedCampaigns((p) => ({
                                        ...p,
                                        [c.id]: !open,
                                      }))
                                    }
                                    className="flex items-center gap-2 text-left flex-1"
                                  >
                                    <span className="text-gray-400">
                                      {open ? "▾" : "▸"}
                                    </span>
                                    <span className="font-semibold">
                                      {c.name || "Campaign"}
                                    </span>
                                    <span className="text-xs text-gray-500">
                                      {c.objective}
                                    </span>
                                  </button>
                                  <div className="flex items-center gap-3">
                                    <span className="text-sm text-gray-600">
                                      ${(totalBudget / 100).toFixed(2)}/day
                                    </span>
                                    <Badge
                                      className={effClass(
                                        c.effective_status || c.status,
                                      )}
                                    >
                                      {c.effective_status || c.status}
                                    </Badge>
                                    {adsManagerUrl(c.id) && (
                                      <a
                                        href={adsManagerUrl(c.id) as string}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-xs text-blue-600 underline whitespace-nowrap"
                                        title="Open this campaign in Meta Ads Manager"
                                      >
                                        Ads Manager ↗
                                      </a>
                                    )}
                                    {rec && (
                                      <div className="flex gap-2 text-xs">
                                        {c.status !== "ACTIVE" && (
                                          <button
                                            disabled={busy}
                                            onClick={() => handleGoLive(rec)}
                                            className="text-green-700 hover:underline disabled:opacity-50"
                                          >
                                            Go live
                                          </button>
                                        )}
                                        {c.status === "ACTIVE" && (
                                          <button
                                            disabled={busy}
                                            onClick={() =>
                                              handleAdStatus(rec, "PAUSED")
                                            }
                                            className="text-yellow-700 hover:underline disabled:opacity-50"
                                          >
                                            Pause
                                          </button>
                                        )}
                                        <button
                                          disabled={busy}
                                          onClick={() => handleDeleteAd(rec)}
                                          className="text-red-600 hover:underline disabled:opacity-50"
                                        >
                                          Delete
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                {/* Expanded: ad sets -> ads -> creatives */}
                                {open && (
                                  <div className="px-4 py-3 space-y-3">
                                    {adsets.length === 0 && (
                                      <p className="text-xs text-gray-400">
                                        No ad sets.
                                      </p>
                                    )}
                                    {adsets.map((a: any) => {
                                      const countries =
                                        a.targeting?.geo_locations?.countries ||
                                        [];
                                      const adList = a.ads?.data || [];
                                      return (
                                        <div
                                          key={a.id}
                                          className="border rounded p-3"
                                        >
                                          <div className="text-xs text-gray-500 mb-2">
                                            Ad set: {a.name} · optimize{" "}
                                            {a.optimization_goal} · $
                                            {(
                                              Number(a.daily_budget || 0) / 100
                                            ).toFixed(2)}
                                            /day
                                            {countries.length
                                              ? ` · ${countries.join(", ")}`
                                              : ""}{" "}
                                            · {a.effective_status}
                                          </div>
                                          {adList.length === 0 && (
                                            <p className="text-xs text-gray-400">
                                              No ads.
                                            </p>
                                          )}
                                          <div className="space-y-2">
                                            {adList.map((ad: any) => {
                                              const cr = ad.creative || {};
                                              const info =
                                                cr.source_instagram_media_id
                                                  ? mediaInfo(
                                                      cr.source_instagram_media_id,
                                                    )
                                                  : null;
                                              const thumb =
                                                cr.thumbnail_url ||
                                                cr.image_url ||
                                                info?.thumbnail_url ||
                                                info?.media_url;
                                              return (
                                                <div
                                                  key={ad.id}
                                                  className="flex items-center gap-3"
                                                >
                                                  {thumb ? (
                                                    <img
                                                      src={thumb}
                                                      alt="creative"
                                                      className="w-12 h-12 object-cover rounded"
                                                    />
                                                  ) : (
                                                    <div className="w-12 h-12 rounded bg-gray-100" />
                                                  )}
                                                  <div className="flex-1">
                                                    <div className="text-sm">
                                                      {ad.name}
                                                    </div>
                                                    <div className="text-xs text-gray-500">
                                                      {cr.call_to_action_type
                                                        ? `CTA: ${cr.call_to_action_type}`
                                                        : "No CTA"}
                                                      {cr.instagram_permalink_url ? (
                                                        <>
                                                          {" · "}
                                                          <a
                                                            href={
                                                              cr.instagram_permalink_url
                                                            }
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-blue-600 underline"
                                                          >
                                                            post
                                                          </a>
                                                        </>
                                                      ) : null}
                                                    </div>
                                                  </div>
                                                  <Badge
                                                    className={effClass(
                                                      ad.effective_status ||
                                                        ad.status,
                                                    )}
                                                  >
                                                    {ad.effective_status ||
                                                      ad.status}
                                                  </Badge>
                                                </div>
                                              );
                                            })}
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </TabsContent>
                </Tabs>
              </Card>
            )}
          </div>
        </div>
      </div>

      {/* Boost / Partnership Ad form */}
      {boostFor && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="w-[440px] max-w-[92vw] rounded-lg bg-white p-6 shadow-xl">
            <h3 className="mb-1 text-lg font-bold">Boost as Partnership Ad</h3>
            <p className="mb-4 text-sm text-gray-500">
              @{boostFor.username} · runs from the creator's handle with the
              Paid Partnership label. Created paused.
            </p>
            <div className="space-y-3">
              <div>
                <label className="text-xs text-gray-600">Ad name</label>
                <Input
                  value={boostForm.name}
                  onChange={(e) =>
                    setBoostForm({ ...boostForm, name: e.target.value })
                  }
                />
              </div>
              <div className="flex gap-3">
                <div className="flex-1">
                  <label className="text-xs text-gray-600">Objective</label>
                  <select
                    className="w-full rounded border px-2 py-2 text-sm"
                    value={boostForm.objective}
                    onChange={(e) =>
                      setBoostForm({ ...boostForm, objective: e.target.value })
                    }
                  >
                    <option value="OUTCOME_AWARENESS">Awareness (reach)</option>
                    <option value="OUTCOME_ENGAGEMENT">Engagement</option>
                    <option value="OUTCOME_TRAFFIC">Traffic</option>
                    <option value="OUTCOME_SALES">Sales</option>
                  </select>
                </div>
                <div className="w-28">
                  <label className="text-xs text-gray-600">
                    Daily budget ($)
                  </label>
                  <Input
                    type="number"
                    min={1}
                    value={boostForm.dailyBudgetUsd}
                    onChange={(e) =>
                      setBoostForm({
                        ...boostForm,
                        dailyBudgetUsd: Number(e.target.value),
                      })
                    }
                  />
                </div>
              </div>
              <div>
                <label className="text-xs text-gray-600">
                  Countries (comma-separated)
                </label>
                <Input
                  value={boostForm.countries}
                  onChange={(e) =>
                    setBoostForm({ ...boostForm, countries: e.target.value })
                  }
                />
              </div>
              <div className="flex gap-3">
                <div className="w-36">
                  <label className="text-xs text-gray-600">CTA</label>
                  <select
                    className="w-full rounded border px-2 py-2 text-sm"
                    value={boostForm.ctaType}
                    onChange={(e) =>
                      setBoostForm({ ...boostForm, ctaType: e.target.value })
                    }
                  >
                    <option value="LEARN_MORE">Learn more</option>
                    <option value="SHOP_NOW">Shop now</option>
                    <option value="SIGN_UP">Sign up</option>
                  </select>
                </div>
                <div className="flex-1">
                  <label className="text-xs text-gray-600">
                    CTA link <span className="text-red-500">*</span>
                  </label>
                  <Input
                    required
                    type="url"
                    placeholder="https://..."
                    value={boostForm.ctaLink}
                    onChange={(e) =>
                      setBoostForm({ ...boostForm, ctaLink: e.target.value })
                    }
                  />
                </div>
              </div>
              <label className="flex items-center gap-2 text-sm text-gray-600">
                <input
                  type="checkbox"
                  checked={boostForm.dryRun}
                  onChange={(e) =>
                    setBoostForm({ ...boostForm, dryRun: e.target.checked })
                  }
                />
                Dry run (log payload, create nothing)
              </label>
            </div>
            <div className="mt-5 flex justify-end gap-2">
              <Button
                className="bg-gray-200 text-gray-800 hover:bg-gray-300"
                onClick={() => setBoostFor(null)}
                disabled={boosting}
              >
                Cancel
              </Button>
              <Button
                onClick={submitBoost}
                // Meta requires a destination for the call to action — a CTA type
                // without value.link fails the creative (subcode 2061015).
                disabled={boosting || !boostForm.ctaLink.trim()}
              >
                {boosting ? "Creating..." : "Create ad (paused)"}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
